import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import toast from 'react-hot-toast';

import { namespaces, useSharedTranslation } from 'us-react-components/dist/hooks/useSharedTranslation';
import { GeneralAvailabilityModal } from 'us-react-components/dist/GeneralAvailabilityModal/GeneralAvailabilityModal';
import {
  Booking,
  BookingService,
  SitterDashboardData,
  SitterDashboardDataService
} from 'us-web-services';
import { JoinFacebookGroup } from '../../components/Dashboard';
import { useDependencies } from '../../dependencies';
import { Routes } from '../../Routes';
import { MainContainer } from './MainContainer';
import { SideBar } from './SideBar';

export const Dashboard = observer((): JSX.Element => {
  const { t } = useSharedTranslation(namespaces.caregiver);
  const { stores: { sitter, user } } = useDependencies();
  const [dashboardData, setDashboardData] = useState<SitterDashboardData>();
  const [activeBookings, setActiveBookings] = useState<Booking[]>([]);

  const getDashboardData = async (): Promise<void> => {
    if (!user.user?.sitter) {
      window.location.href = `${Routes.app}${Routes.parent.dashboard}`;
    } else {
      const response = (await SitterDashboardDataService.get(sitter.sitter.id || 0)).data;
      setDashboardData(response.data);
    }
  };

  const getActiveBookings = async (): Promise<void> => {
    const config = {
      params: {
        sitterId: user.user.id,
        userId: user.user.id,
        limit: 4,
        filterType: 'all_active'
      },
    };

    const response = (await BookingService.getByFilter(config)).data;
    setActiveBookings(response.data);
  };

  const availabilityUpdated = (): void => {
    toast.success(t('pages.sitterProfile.availability.updated'));
  };

  useEffect(() => {
    getDashboardData();
    getActiveBookings();
  }, []);

  return (<article className='container py-3'>
      <div className='w-full'>
        <div className='flex flex-col md:flex-row md:mt-10'>
          <SideBar activeBookings={activeBookings} />
          {dashboardData && <MainContainer dashboardData={dashboardData} />}
          <div className='block sm:hidden'>
            <JoinFacebookGroup />
          </div>
        </div>
      </div>
      <GeneralAvailabilityModal sitter={sitter.sitter} onSuccess={availabilityUpdated} />
    </article>
  )
});
